import { useContext } from 'react';

import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';

import { DeviceContext } from '@vyce/core/src/contexts';
import { MAIN_CONTAINER_ID } from '@vyce/core/src/constants';
import { PhoneOrEmail } from '@vyce/core/src/views/invites/components/PhoneOrEmail';
import { BulkPhoneEntryApi } from '@vyce/core/src/views/invites/types';
import { ButtonTitleWithLoading } from '@vyce/core/src/components';

interface Props {
  open: boolean;
  onClose: () => void;
  isPhoneInputDisabled: boolean;
  handleEmailFieldKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  handlePhoneFieldKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  addEmailToList: () => void;
  addPhoneToList: () => void;
  deleteContact: (contact: string) => void;
  emails: string[];
  phones: string[];
  setIsPhoneInputDisabled: (isPhoneInputDisabled: boolean) => void;
  bulkPaste?: BulkPhoneEntryApi;
  bulkLimitHint?: string;
  sendFormRecipients: () => void;
  loading: boolean;
}

export const FormSendDialog: React.FC<Props> = ({
  open,
  onClose,
  isPhoneInputDisabled,
  handleEmailFieldKeyDown,
  handlePhoneFieldKeyDown,
  addEmailToList,
  addPhoneToList,
  deleteContact,
  emails,
  phones,
  setIsPhoneInputDisabled,
  bulkPaste,
  bulkLimitHint,
  sendFormRecipients,
  loading,
}) => {
  const { isMobile } = useContext(DeviceContext);
  return (
    <Dialog
      container={document.getElementById(MAIN_CONTAINER_ID)}
      maxWidth="md"
      fullScreen={isMobile}
      open={open}
      onClose={onClose}
    >
      <DialogTitle>Send the form to new recipients</DialogTitle>

      <DialogContent style={{ minWidth: 500 }}>
        <PhoneOrEmail
          isPhoneInputDisabled={isPhoneInputDisabled}
          handleEmailFieldKeyDown={handleEmailFieldKeyDown}
          handlePhoneFieldKeyDown={handlePhoneFieldKeyDown}
          addEmailToList={addEmailToList}
          addPhoneToList={addPhoneToList}
          deleteContact={deleteContact}
          emails={emails}
          phones={phones}
          setIsPhoneInputDisabled={setIsPhoneInputDisabled}
          bulkPaste={bulkPaste}
          bulkLimitHint={bulkLimitHint}
        />
      </DialogContent>

      <DialogActions>
        <Button size="large" variant="outlined" onClick={onClose}>
          Cancel
        </Button>

        <Button
          style={{ width: 100 }}
          size="large"
          onClick={sendFormRecipients}
          color="primary"
          variant="contained"
          disabled={loading || (emails.length === 0 && phones.length === 0)}
        >
          <ButtonTitleWithLoading title="Send" loaderVariant="paper" loading={loading} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
